import { bankEndPoint } from "./base.config";

export const hsb = {
  getBankBalance: bankEndPoint + '/api/handelsbanken/get-bank-balance',
}